const registry = document.querySelector('script[data-elena-homepage-modules]');

if (registry) {
  const modules = JSON.parse(registry.textContent);
  const pending = new Map(Object.entries(modules));
  let scheduled = false;
  const additions = new Set();

  const scan = (root) => {
    for (const [selector, url] of pending) {
      if ((root instanceof Element && root.matches(selector)) || root.querySelector(selector)) {
        pending.delete(selector);
        import(url).catch((error) => {
          pending.set(selector, url);
          console.warn('[elena-homepage] Component load failed:', error);
        });
      }
    }
  };

  const observer = new MutationObserver((records) => {
    if (!pending.size) return;
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node instanceof Element) additions.add(node);
      }
    }
    if (scheduled || !additions.size) return;
    scheduled = true;
    queueMicrotask(() => {
      scheduled = false;
      for (const node of additions) {
        if (node.isConnected) scan(node);
      }
      additions.clear();
    });
  });

  scan(document);
  observer.observe(document.body, { childList: true, subtree: true });
  window.addEventListener('pagehide', () => observer.disconnect(), { once: true });
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) observer.observe(document.body, { childList: true, subtree: true });
  });
}
